import { styled } from "theme/default/styled";
import { setFlexDFAIC } from "theme/setter/setFlexValues/setFlexDFAIC";

export const SGroupHeaderCell = styled.div`
  padding: 6px 6px 6px 12px;

  ${setFlexDFAIC};
`;
